import React, { useEffect, useState, useRef } from "react";
import RequestHandler from "util/RequestHandler";
import PosVolumeReportMonthly from "./PosVolumeReportMonthly";
import PosVolumeReportDaily from "./PosVolumeReportDaily";
import config from "../../util/ApiforContext";
import Replace2x from "../../util/Extensions/ReplaceExtension";

import {Tabs, Col, Row, Tooltip, message, Button, Modal, Form, Input, Select, DatePicker} from "antd";
import { BarsOutlined, FileExcelOutlined } from "@ant-design/icons";
import { lowerCase } from "lodash";
const { TabPane } = Tabs;

const PosVolumeReport = (props) => {

  const formRef = useRef();

  const [form] = Form.useForm();


  const [reportFilters, setReportFilters] = useState({
    daily: {},
    monthly: {},
  });
  const [bankSelect, setBankSelect] = useState({
    data: [],
    loading: false,
  });

  const tenantId = localStorage.getItem("tenantId");
  const [activeTabKey, setActiveTabKey] = useState(lowerCase(tenantId) ==  lowerCase('FEBB740F-8CA4-EE11-BF1B-0050569D6B4F') ? "2" : "1");
  const [useBankBasedReport, setUseBankBasedReport] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [operationDateRangeDisabled, setOperationDateRangeDisabled] = useState(false);
  const [dateRangeDisabled, setDateRangeDisabled] = useState(false);


  useEffect(() => {
    getBanks();


    RequestHandler.get("/TenantParameter/GetByTenant").then(response => {
      setUseBankBasedReport(response.isUseBankBasedPosReport);
    });
  }, [])

  const onClickExportExcel = () => {
    const hideMessage = message.loading("Excel indiriliyor...", 0);

    if (activeTabKey === "1") {
      RequestHandler.post(
        "/PosTransaction/MonthlyPosVolumeReportExportExcel",
        reportFilters.monthly
      ).then((response) => {
        hideMessage();

        if (response.success) {
          window.open(
            `${
              config.apiUrl
            }/PosTransaction/MonthlyPosVolumeReportDownloadExcel?fileName=${
              response.data
            }&t=${RequestHandler.getToken()}`
          );
        }
      });
    } else {
      RequestHandler.post(
        "/PosTransaction/DailyPosVolumeReportExportExcel",
        reportFilters.daily
      ).then((response) => {
        hideMessage();

        if (response.success) {
          window.open(
            `${
              config.apiUrl
            }/PosTransaction/DailyPosVolumeReportDownloadExcel?fileName=${
              response.data
            }&t=${RequestHandler.getToken()}`
          );
        }
      });
    }
  };

  const onMonthlyFilterChange = (filterData) => {
    setReportFilters({ ...filterData, monthly: filterData });
  };

  const onDailyFilterChange = (filterData) => {
    setReportFilters({ ...reportFilters, daily: filterData });
  };

  const onBankBasedReportModalOk = () => {
    form.submit();
  }

  const handleCancelOtpModal = () => {
    setShowModal(false);
  };

  const getBanks = () => {
    setBankSelect({
      ...bankSelect,
      loading: true,
    });
    RequestHandler.get(`/PosTransaction/AddedBanks?$select=id,name`).then(
      (response) => {
        setBankSelect({
          data: response,
          loading: false,
        });
      }
    );
  };

  const bankBasedReportExport = (values) => {

    setConfirmLoading(true);
    const postModel = {
      bankId: values.bankId
    };

    if (values.dateRange) {
      [postModel.startDate, postModel.endDate] = values.dateRange;

    }

    if (values.operationDateRange) {
      [postModel.operationStartDate, postModel.operationEndDate] = values.operationDateRange;
    }

    RequestHandler.post(`/PosTransaction/BankBasedReportExport`, postModel).then((response) => {
      setConfirmLoading(false);
      setShowModal(false);
      setDateRangeDisabled(false);
      setOperationDateRangeDisabled(false);
      form.resetFields();
    });
  }

  return (
    <>
      <Row>
        <Col xs={24} md={12} lg={16}>
          <p style={{ fontSize: "120%", marginTop: -5 }}>
            <BarsOutlined /> POS CİRO RAPORU
          </p>
        </Col>
        <Col xs={24} md={12} lg={8} style={{ textAlign: "right" }}>

          {
            useBankBasedReport ? <><Button type="primary" onClick={() => setShowModal(true)}><FileExcelOutlined /> Banka Bazlı Excel Al</Button></>:<></>
          }

          <Tooltip title="Excel İndir">
            <a
              style={{
                color: "green",
                fontSize: "180%",
                marginRight: 30,
              }}
              onClick={onClickExportExcel}
            >
              <FileExcelOutlined />
            </a>
          </Tooltip>
        </Col>
      </Row>

      <Tabs
        defaultActiveKey={activeTabKey}
        onChange={(activeKey) => {
          setActiveTabKey(activeKey);
        }}
      >
        <TabPane tab="Ay Bazlı" key="1">
          <PosVolumeReportMonthly onFilterChange={onMonthlyFilterChange} />
        </TabPane>
        <TabPane tab="Gün Bazlı" key="2">
          <PosVolumeReportDaily onFilterChange={onDailyFilterChange} />
        </TabPane>
      </Tabs>


      <Modal closable={false} maskClosable={false} visible={showModal} onOk={onBankBasedReportModalOk} okText="Excel Al" keyboard={false} cancelText="İptal" onCancel={handleCancelOtpModal} confirmLoading={confirmLoading} title="Banka Bazlı Excel">
        <Form
          onFinish={bankBasedReportExport}
          form={form}
          ref={formRef}
          layout={"vertical"}
        >
         <Form.Item name="bankId" label="Banka"  rules={[{ required: true }]}>
           <Select
             allowClear
             showSearch
             placeholder="Tümü"
             loading={bankSelect.loading}
             filterOption={(input, option) =>
               option.props.children
                 .toLocaleLowerCase("tr-TR")
                 .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
             }
           >
             {bankSelect.data.map((item) => (
               <Select.Option key={item.id} value={item.id}>
                 {item.name}
               </Select.Option>
             ))}
           </Select>
         </Form.Item>

            <Form.Item name="dateRange" label="Gün Sonu Tarihi Aralığı" rules={[{ required: !dateRangeDisabled }]}>
              <DatePicker.RangePicker
                style={{ width: "100%" }}
                picker={props.monthly ? "month" : "date"}
                format={props.monthly ? "MMMM YYYY" : "DD.MM.YYYY"}
                disabled={dateRangeDisabled}
                onChange={(date) => {
                  if(date) {
                    setOperationDateRangeDisabled(true);
                  }
                  else {
                    setOperationDateRangeDisabled(false);
                  }
                }}
              />
            </Form.Item>

            <Form.Item name="operationDateRange" label="İşlem Tarihi Aralığı" rules={[{ required: !operationDateRangeDisabled }]}>
              <DatePicker.RangePicker
                style={{ width: "100%" }}
                picker={props.monthly ? "month" : "date"}
                format={props.monthly ? "MMMM YYYY" : "DD.MM.YYYY"}
                disabled={operationDateRangeDisabled}
                onChange={(date) => {
                  if(date) {
                    setDateRangeDisabled(true);
                  }
                  else {
                    setDateRangeDisabled(false);
                  }
                }}
              />
            </Form.Item>

        </Form>
      </Modal>
    </>
  );
};

export default PosVolumeReport;
